export default "__VITE_ASSET__ntqli3CL__"